export const TAB_NAME = {
  questions: 'Questions',
  quotes: 'Quotes',
  demographics: 'Demographics',
};

export const TYPE_QUESTIONS = {
  AUDIO_VIDEO: 'audio_video',
  IMAGE_SELECT: 'image_select',
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
  RANGE: 'range',
  WRITTEN: 'written',
  TASK: 'task',
  URL: 'url',
};

export const DEMO_ID = '00000000-0000-0000-0000-000000000000';

export const HOUSEHOLD_INCOME_LABELS = [{
  data: '<$25,000',
  display: '<$25k',
}, {
  data: '$25,001-$50,000',
  display: '$25k-$50k',
}, {
  data: '$50,001-$100,000',
  display: '$50k-$100k',
}, {
  data: '$100,001-$150,000',
  display: '$100k-$150k',
}, {
  data: '$150,001-$200,000',
  display: '$150k-$200k',
}, {
  data: '>$200,001',
  display: '>$200,001',
}];
